"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UccActivationStatus = exports.UccAccountCreationResult = void 0;
var UccAccountCreationResult;
(function (UccAccountCreationResult) {
    UccAccountCreationResult["accountCreated"] = "accountCreated";
    UccAccountCreationResult["accountNotCreated"] = "accountNotCreated";
    // Account creation was blocked because the applicant's Experian credit report is frozen. The
    // backend already sends an unfreeze SMS and re-enqueues a retry, but these variants let the
    // frontend offer an inline instant-unlock flow instead of dead-ending at the under-review screen.
    // Existing consumers only branch on `=== accountCreated`, so these fall through their not-created paths.
    UccAccountCreationResult["accountNotCreatedExperianFrozenPrimary"] = "accountNotCreatedExperianFrozenPrimary";
    UccAccountCreationResult["accountNotCreatedExperianFrozenCoApplicant"] = "accountNotCreatedExperianFrozenCoApplicant";
})(UccAccountCreationResult || (exports.UccAccountCreationResult = UccAccountCreationResult = {}));
var UccActivationStatus;
(function (UccActivationStatus) {
    UccActivationStatus["readyToActivate"] = "readyToActivate";
    UccActivationStatus["notReadyToActivate"] = "notReadyToActivate";
})(UccActivationStatus || (exports.UccActivationStatus = UccActivationStatus = {}));
